import { OrganLayout } from "@/components/OrganLayout";
import { Link } from "react-router-dom";
import { StatusBadge } from "@/components/DadStatus";
export default function Marketing() {
 return <OrganLayout organId="mouth" data-testid="marketing-page" description="Il modo in cui l’azienda parla verso l’esterno: comunica, racconta, promuove e attrae." status={<div className="dad-panel"><StatusBadge state="unknown">Area in sviluppo · Dati insufficienti</StatusBadge></div>}>
  <div className="dad-panel">
   <p>Il modo in cui l’azienda parla verso l’esterno: comunica, racconta, promuove e attrae.</p>
   <p>Questa area non raccoglie ancora dati e non offre operazioni di pubblicazione.</p>
   <h2>Ambiti previsti</h2><ul><li>Marketing, campagne e promozioni</li><li>Comunicazione aziendale e reputazione</li><li>Sito web, social media e brand</li><li>Contenuti e newsletter</li><li>Comunicazioni verso clienti e mercato</li></ul>
   <p>Clienti, ordini, fatturazione, produzione e servizi rimangono in Respiro.</p>
   <Link to="/sales" className="dad-text-link">Apri Vendite & Operazioni</Link>
  </div>
 </OrganLayout>;
}
